<template>
  <div class="custom-list-wrapper">
    <div v-show="$loading.isLoading('getContactAddresses')">
      <span>Loading...</span>
    </div>
    <div
      class="custom-list-header"
      v-show="!$loading.isLoading('getContactAddresses')"
    >
      <b-button
        variant="outline-secondary"
        size="sm"
        @click="newAddress"
      >Add</b-button>
      <b-button
        variant="outline-secondary"
        size="sm"
        @click="confirmDelete"
        v-show="isShowDelete"
      >Delete</b-button>
      <b-button
        variant="outline-secondary"
        size="sm"
        @click="primaryAddress"
        v-show="isShowPrimary"
      >Set as Primary</b-button>
      <span
        class="custom-title"
        v-show="showTitle"
      >Addresses</span>
    </div>
    <div
      class="custom-list"
      v-show="!$loading.isLoading('getContactAddresses')"
    >
      <div
        v-for="item of contactAddresses"
        :key="item.contactAddress"
      >
        <contact-address-record
          :recordData="item"
          @itemChecked="itemChecked"
          @editItem="editAddress"
          @viewItem="viewAddress"
        />
      </div>
    </div>
    <dialog-address
      v-model="actionAddress"
      :address="addressRecord"
      @closing="closeModal"
      @send="sendAddress"
    />
    <confirm-delete
      v-model="actionDelete"
      :tag="'Address(es)'"
      @closing="closeModal"
      @delete="performDelete"
    />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import DialogAddress from '@/components/contacts/forms/address'
import ContactAddressRecord from '@/components/contacts/listings/contact-address-record'
import ConfirmDelete from '@/components/contacts/forms/confirm-delete'
export default {
  name: 'contact-addresses',
  components: {
    DialogAddress,
    ContactAddressRecord,
    ConfirmDelete
  },
  props: {
    contact: {
      type: Object
    },
    showTitle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      actionAddress: null,
      actionDelete: null,
      isShowDelete: false,
      isShowPrimary: false,
      recordChecked: null,
      addressRecord: undefined,
      actionAddressMap: null
    }
  },
  computed: {
    ...mapGetters('contacts', ['contactAddresses'])
  },
  methods: {
    ...mapActions('contacts', [
      'saveAddress',
      'deleteAddress',
      'setPrimaryAddress',
      'setCheckedAddress',
      'getContactAddresses',
      'addAddress'
    ]),
    closeModal() {
      this.actionAddress = null
      this.actionDelete = null
      this.addressRecord = undefined
      this.recordChecked = null
      this.actionAddressMap = null
    },
    itemChecked(value, checked) {
      this.isShowDelete = checked
      this.isShowPrimary = checked
      this.recordChecked = null
      if (checked) {
        this.recordChecked = value
      }
      this.setCheckedAddress({
        contactAddress: value.contactAddress,
        isChecked: checked
      })
    },
    newAddress() {
      var address = {
        firm: this.contact.firm,
        contact: this.contact.contact,
        contactAddress: -1,
        address: -1,
        addressType: 0,
        addressLines: '',
        city: '',
        stateProvince: 0,
        postalCode: '',
        country: 0,
        addressNote: ''
      }
      this.addAddress(address)
      this.addressRecord = address
      this.actionAddress = this.contact
    },
    editAddress(data) {
      this.addressRecord = data
      this.actionAddress = this.contact
    },
    viewAddress(data) {
      this.addressRecord = data
      this.actionAddressMap = this.contact
    },
    confirmDelete() {
      this.actionDelete = true
    },
    async performDelete() {
      this.actionDelete = false
      this.isShowDelete = false
      this.isShowPrimary = false
      this.recordChecked = null
      let addresses = []
      for (let address of this.contactAddresses) {
        if (address.isChecked) {
          addresses.push({
            contactAddress: address.contactAddress,
            contact: this.contact.contact
          })
        }
      }
      for (let address of addresses) {
        await this.deleteAddress(address)
      }
      await this.getContactAddresses(this.contact.contact)
    },
    async primaryAddress() {
      let data = {
        id: this.recordChecked.contactAddress,
        contact: this.contact.contact
      }
      await this.setPrimaryAddress(data)
      this.isShowDelete = false
      this.isShowPrimary = false
      this.recordChecked = null
    },
    async sendAddress(data) {
      this.actionAddress = null
      this.addressRecord = undefined
      var address = this.contactAddresses.find(
        x => parseInt(x.contactAddress) === parseInt(data)
      )
      if (address !== null) {
        await this.saveAddress(address)
        await this.getContactAddresses(this.contact.contact)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-list-wrapper {
  background-color: #ffffff;
  max-height: 210px;
  height: 210px;
  padding: 2px;
}
.custom-list-header {
  text-align: left;
  padding: 5px;
  border-bottom: 1px solid rgb(144, 144, 144);
  margin-bottom: 5px;
}
.custom-list {
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 5px;
  margin-left: 5px;
  margin-right: 5px;
  height: 155px;
}
.custom-title {
  float: right;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/contacts/listings/contact-addresses.vue